import isEmpty from "lodash/isEmpty";
import isNumber from "lodash/isNumber";
import isObject from "lodash/isObject";
import some from "lodash/some";
import toString from "lodash/toString";
import trim from "lodash/trim";
export const hasEmptyRequiredFields = (obj, requiredFields) => {
    if (isEmpty(obj) || !isObject(obj))
        return true;
    return some(requiredFields, field => isNumber(obj[field]) ? obj[field] === 0 : isEmpty(trim(toString(obj[field]))));
};
